import { MODES } from "@/lib/activities";

const TINT = {
  reflect: { bg: "hsl(var(--spark-warmth))", accent: "#2C50A0", border: "rgba(44,80,160,0.3)" },
  notice:  { bg: "hsl(var(--spark-cool))",   accent: "#17171C", border: "rgba(0,0,0,0.18)" },
  act:     { bg: "hsl(var(--spark-ivory))",  accent: "#17171C", border: "rgba(0,0,0,0.14)" },
};

export const ModeTag = ({ mode, className = "" }) => {
  const t = TINT[mode];
  return (
    <span
      data-testid={`mode-tag-${mode}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${className}`}
      style={{ background: t.bg, color: mode === "act" ? "#17171C" : mode === "notice" ? "#17171C" : "#1F3D80", border: `1px solid ${t.border}` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: t.accent }} />
      {MODES[mode].label}
    </span>
  );
};

// The intended coaching interaction, shown as a rhythm of beats — who does what, in what order.
export const ModeRhythm = ({ mode }) => {
  const m = MODES[mode];
  const t = TINT[mode];
  return (
    <section data-testid={`mode-rhythm-${mode}`} className="rounded-3xl p-7 sm:p-8" style={{ background: t.bg, border: `1px solid ${t.border}` }}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <ModeTag mode={mode} />
        <span className="text-xs text-[#8A8A91]">How this activity works</span>
      </div>
      <p className="mt-4 spark-voice text-xl sm:text-2xl leading-snug text-[#17171C] max-w-xl">{m.tagline}</p>
      <ol className="mt-6 grid sm:grid-cols-4 gap-x-6 gap-y-4">
        {m.rhythm.map((beat, i) => (
          <li key={i} className="relative">
            <div className="flex items-center gap-2">
              <span className="text-xs tabular-nums text-[#8A8A91]">{String(i + 1).padStart(2, "0")}</span>
              <span className="h-px flex-1" style={{ background: t.accent, opacity: 0.5 }} />
            </div>
            <p className="mt-2 spark-eyebrow" style={{ color: beat.who === "spark" ? t.accent === "#17171C" ? "#1F3D80" : t.accent : "#8A8A91" }}>
              {beat.who === "spark" ? "Spark" : "You"}
            </p>
            <p className="mt-1 text-sm leading-relaxed text-[#17171C]">{beat.text}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};
